// extracted by mini-css-extract-plugin
export default {"paymentMethod":"OioW2Knfjoekd3F0uulV","icon":"LlXpAc9mj8Iki1aWl7tb","bordered":"tPW3nov1rUqx7ysUQVX1"};